/*@ngInject*/
const FormUpgradeRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.upgradeSubmissionForms = function (submissionId) {
        let url = '/rest/Submission/' + submissionId + '/upgradeForms';

        return this.post(url);
    };

    this.upgradeAccountForms = function (accountId) {
        let url = '/rest/Account/' + accountId + '/upgradeForms';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('formUpgradeRepository', FormUpgradeRepository);
